export default "__VITE_ASSET__d4f850bb__"